import { Box, Typography } from '@atgfr8/atg-ui-tailwind';
import { EmailIcon, PhoneIcon } from '@atgfr8/icons';
import { CarrierLaneSearch } from '@store/carriers/laneSearch';
import { formatPhoneNumber } from '@utils/phoneNumberFormat';

import classes from './classes';

const typographyStyle = {
  fontFamily: 'Roboto',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '24px',
  color: 'rgba(0, 0, 0, 0.6)',
  overflowWrap: 'anywhere',
};

const iconStyles = {
  color: '#026EA1',
  width: '15px',
  height: '15px',
  marginRight: '4px',
};
export const CarrierData = (data: CarrierLaneSearch) => {
  return (
    <Box class="flex flex-col text-[12px] leading-snug">
      <b>{data.carrier}</b>
      <span style={typographyStyle}>{`${data.contact} ${
        data.contactType ? `(${data.contactType})` : ''
      }`}</span>
      <span class="flex items-center gap-1.5">
        <PhoneIcon style={iconStyles} />
        <a
          href={`tel:${data.contactEmail}`}
          style={{ color: '#026EA1' }}
          class="hover:underline!"
        >
          {formatPhoneNumber(data.contactPhone)}
        </a>
      </span>
      <span class="flex items-center gap-1.5">
        <EmailIcon style={iconStyles} />
        <a
          href={`mailto:${data.contactEmail}`}
          style={{ color: '#026EA1' }}
          class="hover:underline!"
        >
          {data.contactEmail}
        </a>
      </span>
    </Box>
  );
};

export const CarrierOriginData = (data: CarrierLaneSearch) => {
  return (
    <Box class="flex flex-col">
      <Typography variant="h1" class={classes.text}>
        {data.originCity}, {data.originState} {data.originZip}
      </Typography>
    </Box>
  );
};

export const CarrierDestinationData = (data: CarrierLaneSearch) => {
  if (data.isMasked === true) return null;
  const parts = [data.destCity, data.destState, data.destZip].filter(Boolean);
  return (
    <Box class="flex flex-col">
      <Typography variant="h1" class={classes.text}>
        {parts.join(', ')}
      </Typography>
    </Box>
  );
};

export const CarrierStopsData = (data: CarrierLaneSearch) => {
  return (
    <Box class="flex flex-col">
      <Typography variant="h1" class={classes.text}>
        {`${data.pickUps} : ${data.dropOffs}`}
      </Typography>
    </Box>
  );
};
